<template>
  <v-row v-if="dialog" justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      transition="dialog-top-transition"
      max-width="750px"
    >
      <v-card>
        <div class="container">
          <div class="card-title">
            <img
              src="img/icons_v2/ico-close@3x.png"
              width="45px"
              height="45px"
              @click="$emit('close-dialog', false)"
              class="icon-close"
            />
            <div class="d-flex">
              <img src="/img/icons/list-icon.svg" width="65px" height="65px" />
              <div class="title">
                <span class="font-30 font-w-600">รายชื่อร้าน</span>
                <span class="text-sub">วันที่: {{ date }}</span>
              </div>
            </div>
            <span v-show="action" class="text-sub"
              >{{ countCustomerList }} ร้าน</span
            >
          </div>

          <CustomerAutocomplete
            :item="customer"
            @action="actionAutocomplete"
            :date="date"
          />

          <div v-if="action" class="card-list">
            <!-- #condition ['วางแผนโดย, ร้านที่วางแผนเอง] -->
            <div
              v-if="
                Array.isArray(resultCustomerList) &&
                resultCustomerList.length > 0
              "
              class="card-item"
            >
              <div class="d-flex">
                <span class="font-w-600 pr-2">วางแผนโดย</span>
                <button class="btn-logo">SCG</button>
              </div>

              <div
                v-if="
                  Array.isArray(resultCustomerList) &&
                  resultCustomerList[0].length > 0
                "
              >
                <PlanCard
                  v-for="(item, index) in resultCustomerList[0]"
                  :key="index"
                  :plan="item"
                />
              </div>
              <div v-else class="text-center my-4">
                <span class="font-16 text-sub">ไม่พบแผนการเข้าเยี่ยม</span>
              </div>
            </div>

            <div class="card-item">
              <div class="d-flex">
                <span class="font-w-600 pr-2">ร้านที่วางแผนเอง</span>
              </div>

              <div
                v-if="
                  Array.isArray(resultCustomerList) &&
                  resultCustomerList[1].length > 0
                "
              >
                <PlanCard
                  v-for="(item, index) in resultCustomerList[1]"
                  :key="index"
                  :plan="item"
                />
              </div>
              <div v-else class="text-center my-4">
                <span class="font-16 text-sub">ไม่พบแผนการเข้าเยี่ยม</span>
              </div>
            </div>
          </div>

          <div v-else class="card-found">
            <img
              src="img/icons_v2/icon-note.png"
              width="125px"
              height="125px"
            />
            <span class="text-sub">ไม่พบแผนการเข้าเยี่ยม</span>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import CustomerAutocomplete from '@/components/v2/calendar/CustomerAutocomplete.vue'
import PlanCard from './PlanCard.vue'

export default {
  props: {
    dialog: Boolean,
    date: String,
  },

  emits: ['action-autocomplete'],

  components: {
    CustomerAutocomplete,
    PlanCard,
  },

  watch: {
    dialog(newValue) {
      if (newValue) {
        this.getLocation()
        this.getCustomerList()
        this.getCustomerOf()
      }
    },
  },

  data() {
    return {
      dataCustomerList: [],
      resultCustomerList: [],
      countCustomerList: null,
      customer: [],
    }
  },

  computed: {
    ...mapState({
      visitStatus: (state) => state.visit.visitStatus,
      location: (state) => state.checkinout.location,
      user: (state) => state.auth.user,
      shop: (state) => state.auth.shop,
    }),

    action() {
      return this.countCustomerList == null ? false : true
    },
  },

  methods: {
    openVisitDetail(customerId, visitId) {
      this.$router.push({ path: `/visitdetail/${customerId}/${visitId}` })
    },

    getCustomerList() {
      const data = {
        method: 'POST',
        headers: this.setheaders,
        body: JSON.stringify({
          date: this.date,
          lat_lng: this.location,
        }),
      }

      fetch(`${this.$baseAPI}/calendar/customerList_byDate`, data)
        .then((response) => {
          return response.json()
        })
        .then((res) => {
          const plan_scg = res.list[0].length
          const plan_user = res.list[1].length

          if (plan_scg === 0 && plan_user === 0) {
            this.dataCustomerList = []
            this.resultCustomerList = []
            this.countCustomerList = null
          } else {
            this.dataCustomerList = res.list // push data list
            this.displayCustomerListUI() // call function format data
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    // format data for display ui
    displayCustomerListUI() {
      const status = this.visitStatus
      const plan_scg = this.dataCustomerList[0]
      const plan_user = this.dataCustomerList[1]
      const count_list = plan_scg.length + plan_user.length
      var { scg, user, result } = []

      // Plan SCG
      if (plan_scg.length !== 0) {
        scg = plan_scg.map(function (item) {
          return {
            visitID: item.visit_id,
            customerID: item.customer_id,
            image: item.customer_pic,
            title: item.customer_name,
            typeName: item.type,
            distance: item.distance,
            status: parseInt(item.status),
            statusName: item.status_name,
            backgroundColor: status[parseInt(item.status)].backgroundColor,
            textColor: status[parseInt(item.status)].textColor,
            borderColor: status[parseInt(item.status)].borderColor,
          }
        })
      } else {
        scg = []
      }

      // Plan User
      if (plan_user.length !== 0) {
        user = plan_user.map(function (item) {
          return {
            visitID: item.visit_id,
            customerID: item.customer_id,
            image: item.customer_pic,
            title: item.customer_name,
            typeName: item.type,
            distance: item.distance,
            status: parseInt(item.status),
            statusName: item.status_name,
            backgroundColor: status[parseInt(item.status)].backgroundColor,
            textColor: status[parseInt(item.status)].textColor,
            borderColor: status[parseInt(item.status)].borderColor,
          }
        })
      } else {
        user = []
      }

      result = [scg, user]
      this.resultCustomerList = result
      this.countCustomerList = count_list
    },

    getCustomerOf() {
      const data = {
        method: 'POST',
        headers: this.setheaders,
        body: JSON.stringify({
          date: this.date,
        }),
      }

      fetch(`${this.$baseAPI}/customer/searchCustomer_Bydate`, data)
        .then((response) => {
          return response.json()
        })
        .then((res) => {
          this.customer = res.items
        })
        .catch((error) => {
          console.log(error)
        })
    },

    actionAutocomplete() {
      this.getCustomerList()
      this.getCustomerOf()
      this.$emit('action-autocomplete')
    },

    getLocation() {
      this.$store.dispatch('checkinout/getLocation')
    },
  },

  mounted() {
    this.getLocation()
  },
}
</script>

<style lang="scss" scoped>
* {
  font-size: 17px;
}
.container {
  padding: 30px;
}
.card-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 20px 0px;
  .title {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
  }
}
.card-list {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  border-radius: 6px;
  background-color: #f1f7fe;
  max-height: 50vh;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 20px;
  margin: 20px 0px;
}

.card-found {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 300px;
  background-color: #f1f7fe;
  border-radius: 6px;
  margin: 20px 0px;
}

.card-item {
  width: 100%;
  margin: 10px 0px;
  & .sub-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    & .description {
      display: flex;
      flex-direction: column;
      margin: 0px 10px;
    }
  }
}
.btn-status {
  margin: 5px;
  padding: 2px;
  width: 180px;
  border-radius: 8px;
}

.icon-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.text-sub {
  color: #999999;
}
</style>
